export default {
  seu:{
    route: {name: 'IndexPage'},
    de:{
      label: 'seu',
      slug: 'seu',
    },
    en:{
      label: 'seu',
      slug: 'seu',

    }
  },
  challenges:{
    route: {name: 'ChallengesPage'},
    de:{
      label: 'challenges',
      slug: 'challenges',
    },
    en:{
      label: 'challenges',
      slug: 'challenges',
    }
  },
  strategy:{
    route: {name: 'StrategyPage'},
    de:{
      label: 'strategie',
      slug: 'strategie',
    },
    en:{
      label: 'strategy',
      slug: 'strategy',
    }
  },
  offer:{
    route: {name: 'OfferPage'},
    de:{
      label: 'angebot',
      slug: 'angebot',
    },
    en:{
      label: 'services',
      slug: 'services',

    }
  },
  engineering:{
    route: {name: 'FieldsPage'},
    de:{
      label: 'engineering',
      slug: 'engineering',
    },
    en:{
      label: 'engineering',
      slug: 'engineering',

    }
  },
  about_us:{
    route: {name: 'AboutUsPage'},
    de:{
      label: 'wir',
      slug: 'wir',
    },
    en:{
      label: 'About',
      slug: 'about',

    }
  },
  blog:{
    route: {name: 'PostsPage'},
    de:{
      label: 'blog',
    },
    en:{
      label: 'blog',
    }
  },
  contact:{
    route: {name: 'ContactUsPage'},
    de:{
      label: 'KONTAKT',
      slug: 'kontakt',
    },
    en:{
      label: 'Contact',
      slug: 'contact',
    }
  },
}



